import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import { Alert } from 'react-bootstrap'
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import { IBindResult } from "../../classes/ExternalQuote";
import { IAppState } from "../../state/interfaces";
import Utilities from "../../classes/Utilities";
import { IQuoteApiClient, IPaths } from "../../classes/Domain";
import QuoteActions from "../../state/appActions";


interface IState extends IQuoteStepState {
}

interface IProps extends IQuoteStepComponentProps {
    bindResult: IBindResult | null,
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class Finish extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    render() {
        return (
            <QuoteStep id="finish" className="policy-details">
                {
                    this.props.bindResult?.isSuccess 
                        ?
                        <div>
                            <div className="titleArea">
                                <h5>Thank you for purchasing your policy with Onward Insurance!</h5>
                            </div>

                            <p className="info">You are covered and moving Onward! Click on the links below to download your insurance documents.</p>

                            {
                                this.props.bindResult?.documents.map((document) => (
                                    <p key={Utilities.uniqueId()}><i className="fas fa-file-download"></i> <a href={document.downloadUrl} target="_blank">{document.name}</a></p>
                                ))
                            }
                        </div>
                        :
                        <div>
                            <Alert variant={"danger"}>
                                <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                                <p>Please review errors below</p>
                                <ul>
                                    {
                                        this.props.bindResult?.errors.map((error) => (
                                            <li key={Utilities.uniqueId()}>
                                                <p className="text-uppercase">
                                                    {error}
                                                </p>
                                            </li>
                                        ))
                                    }
                                </ul>
                                <p><a href={Utilities.getHomePageUrl()} className="font-weight-bold m-b-0"><i className="fas fa-chevron-left"></i> Home</a></p>
                            </Alert>
                        </div>
                }
                

            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        bindResult: state.externalQuote?.bindResult,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.FINISH))
    };
};

export default connect(mapProps, mapDispatch)(Finish);
